import { render, staticRenderFns } from "./LeavePageDetails.vue?vue&type=template&id=48df4d23&scoped=true&"
import script from "./LeavePageDetails.vue?vue&type=script&lang=js&"
export * from "./LeavePageDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48df4d23",
  null
  
)

export default component.exports